import { keyframes, styled } from 'styled-components';
import { Theme } from '../../themes';

export const Root = styled.div<Record<string, never>, Theme>``;

const spin = keyframes`
    0% { 
        transform: rotate(0deg);
    }
    100% { 
        transform: rotate(360deg);
    }
`;

export const Spinner = styled.div<{ opacity: number }>`
    background: linear-gradient(
        to right,
        ${({ theme }) => theme.progressSpinnerColor},
        transparent
    );
    border-radius: 50%;
    width: 14px;
    height: 14px;
    mask: radial-gradient(farthest-side, transparent calc(100% - 4px), black calc(100% - 4px));
    -webkit-mask: radial-gradient(
        farthest-side,
        transparent calc(100% - 4px),
        black calc(100% - 4px)
    );
    animation: ${spin} 2s linear infinite;
    opacity: ${(props) => props.opacity};
    transition: opacity 3s;
`;

export const RootDonut = styled.svg`
    width: 32px;
    height: 32px;
    transform: rotate(-90deg);
`;

export const ProgressCircleInner = styled.circle`
    fill: transparent;
    stroke: ${(props) => props.theme.progressDonutRingColor};
    stroke-width: 4px;
`;

export const ProgressCircle = styled.circle<{ progress: number; max: number }>`
    fill: transparent;
    stroke: ${(props) => props.theme.progressDonutIndicatorColor1};
    stroke-width: 4px;
    stroke-linecap: round;
    transition: stroke-dasharray 0.5s ease;

    stroke-dasharray: ${(props) => (props.progress / props.max) * 88} 100;
`;
